import { useArticleMeta } from "./ArticleMetaContext";
import { resolveArticleAuthor } from "../lib/authors";

export default function AuthorCard({ title = "O autorze" }) {
	const articleMeta = useArticleMeta();
	const author = resolveArticleAuthor(articleMeta);

	if (!author || author.id === "redakcja") {
		return null;
	}

	return (
		<section className="author__card">
			<div className="author">
				<img className="author__avatar" src={author.image} alt={author.name} />

				<div className="author__content">
					<h2 className="author__title">{title}</h2>
					{author.role ? <p className="author__role">{author.role}</p> : null}
				</div>
			</div>

			{author.description ? <p className="author__card__text">{author.description}</p> : null}

			<a className="author__card__link" href={author.path}>
				Czytaj więcej
			</a>
		</section>
	);
}
